export const CATEGORY_KEY = "CATEGORY";

export const CATEGORY_CACHE_KEYS = {
  LIST: [CATEGORY_KEY, "LIST"] as const,
  DETAIL: (id: string) => [CATEGORY_KEY, id] as const,
};
